import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { AppState } from 'src/app/store';
import {
    selectExportBusy,
    selectExportFormats,
    selectExportProgress,
    selectExportProvider
} from '../../../store/interface/interface.state';
import { combineLatest, Observable } from 'rxjs';
import { ExportFormatEnum } from '../../../enum/export-format.enum';
import { interfaceExport } from '../../../store/interface/interface.actions';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-export',
    templateUrl: './export.component.html',
    styleUrls: ['./export.component.scss'],
    imports: [MatIconButton, MatMenuTrigger, IconComponent, MatMenu, MatMenuItem, MatProgressSpinner, MatTooltip, AsyncPipe]
})
export class ExportComponent implements OnInit {

    constructor(private store: Store<AppState>) {
    }

    canDisplay$: Observable<boolean> = this.store.select(selectExportProvider).pipe(
        map(provider => provider !== null)
    );

    busy$: Observable<boolean> = this.store.select(selectExportBusy);

    progress$ = this.store.select(selectExportProgress);
    showProgress$: Observable<boolean> = combineLatest([
        this.store.select(selectExportProgress),
        this.store.select(selectExportBusy)
    ]).pipe(
        map(([ progress, busy ]) => (busy && progress > 0))
    );
    showPreparing$: Observable<boolean> = combineLatest([
        this.store.select(selectExportProgress),
    this.store.select(selectExportBusy)
    ]).pipe(
        map(([ progress, busy ]) => (busy && progress === 0))
    );

    exportCsv$: Observable<boolean> = this.store.select(selectExportFormats).pipe(
        map(formats => formats.indexOf(ExportFormatEnum.CSV) !== -1)
    );

    exportXlsx$: Observable<boolean> = this.store.select(selectExportFormats).pipe(
        map(formats => formats.indexOf(ExportFormatEnum.XLSX) !== -1)
    );

    exportCsv(): void {
        this.store.dispatch(interfaceExport({ format: ExportFormatEnum.CSV }));
    }

    exportXls(): void {
        this.store.dispatch(interfaceExport({ format: ExportFormatEnum.XLSX }));
    }

    ngOnInit(): void {
    }

}
